<template>
<div id="download">
  <div class="sectionIntro">
    <div class="sectionBack"></div>
    <div class="sectionContent">
      <span class="title">{{$t('avatamsaka.download.title')}}</span>
    </div>
  </div>

  <div class="itemsBlocks">
    <div class="itemBlock">
      <p>
        {{$t('avatamsaka.download.intro')}}
      </p>
    </div>
  </div>
<hr/><br/>
  <div class="itemsBlocks">

    <h2>{{$t('avatamsaka.download.area01')}}</h2>
<div class="itemBlock">

    <div class="fileList">
      <ol>
        <li>
          <a href="../static/files/1 藏、漢《華嚴經•淨行品》五異譯校勘本.pdf" download>
          <!-- <a href="#" download> -->
            <i class="fas fa-file-pdf"></i>
            {{$t('avatamsaka.download.a01f01')}}
          </a>
          <div>
            {{$t('avatamsaka.download.a01f01ps')}}
          </div>
        </li>
        <li>
          <a href="../static/files/2 藏、漢《華嚴經•淨行品》五異譯比對本.pdf" download>
          <!-- <a href="#" download> -->
            <i class="fas fa-file-pdf"></i>
            {{$t('avatamsaka.download.a01f02')}}
          </a>
          <div>
            {{$t('avatamsaka.download.a01f02ps')}}
          </div>
        </li>
        <li>
          <a href="../static/files/3 藏譯《華嚴經•淨行品》語彙集.pdf" download>
          <!-- <a href="#"> -->
            <i class="fas fa-file-pdf"></i>
            {{$t('avatamsaka.download.a01f03')}}
          </a>
          <div>
            {{$t('avatamsaka.download.a01f03ps')}}
          </div>
        </li>
        <li>
          <a href="../static/files/4 藏譯《華嚴經•淨行品》語彙別集.pdf" download>
          <!-- <a href="#" download> -->
            <i class="fas fa-file-pdf"></i>
            {{$t('avatamsaka.download.a01f04')}}
          </a>
          <div>
            {{$t('avatamsaka.download.a01f04ps')}}
          </div>
        </li>
        <li>
          <a href="../static/files/5 藏、漢《華嚴經•淨行品》科判.pdf" download>
          <!-- <a href="#" download> -->
            <i class="fas fa-file-pdf"></i>
            {{$t('avatamsaka.download.a01f05')}}
          </a>
          <div>
            {{$t('avatamsaka.download.a01f05ps')}}
          </div>
        </li>
      </ol>
    </div>
    </div>
  </div>

</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'about',
  data() {
    return {
    };
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
    downloadPDf() {
      axios({
        url: 'http://localhost:8000/static/files/s01A.pdf',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'file.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#download {

  text-align: center;

  .fileList {
    margin: 2em 0px;
    text-align: left;
    ol {

      padding: 0px;
      li {
        padding: 1em;
        font-size: 1.3em;
        a {
          color: #314558;
          font-weight: bolder;
        }

        a:hover {
          text-decoration: none;
        }

        i {
          padding-right: 0.7em;
        }

        div {
          font-size: 0.7em;
          color: #314558;
          margin-left: 2.2em;
          border-top: 1px dotted #b2b5b6;
          padding-top: 1em;
        }
      }
      li:nth-child(even) {
        background: #F5F8EE;
      }
    }
  }

  .sectionIntro {
      display: flex;
      padding-bottom: 50px;
      position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      background: #d9e2c4;
      position: absolute;
    }

    .sectionBack::after {
        border-top: 50vh solid #d9e2c4;
        border-right: 100vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;
    }

    .sectionContent{
      position: relative;
      width: 100%;
      text-align: center;
      margin-top: 4em;
        .title {
          padding: 20px;
          padding-left: 0px;
          font-size: 2.2em;
          text-shadow: 0px 0px 10px #fff, 0px 0px 10px #fff,
          0px 0px 10px #fff, 0px 0px 10px #fff, 0px 0px 10px #fff,
          0px 0px 10px #fff, 0px 0px 10px #fff;
        }
    }


    @media (max-width: 768px) {

        display: block;
        flex-direction: row;

        .mapBlocks .sectionBack::after {
          border: none;
        }

        .introCover, .introContent {
          clear: both;
          display: block;
          width: 100%;
          flex: none;
          margin: 0px;
          padding: 40px;
        }

        .introCover {
          position: relative;
          margin: 0;
          img {
            width: 100%;
          }
        }
    }
  }

  .itemsBlocks{
    margin: 0px;
    position: relative;
    h2 {
      position: sticky;
      margin: 0.8em auto;
      padding-left: 100px;
      padding-right: 100px;
      font-weight: bolder;
    }
    .itemBlock {
      position: sticky;
      padding-left: 100px;
      padding-right: 100px;
      padding-bottom: 100px;
      height: 100%;
      overflow: hidden;
      text-align: left;
      img {
        max-width: 600px;
        max-height: 100%;
        padding-right: 40px;
        overflow: hidden;
        position: relative;
        float: left;
        clear: left;
      }
    }

    .teamBlock {
      display: flex;
      flex-direction: row;
      margin-bottom: 150px;

      .content {
        flex: 1;
        background: rgba(#d9e2c3, 0.43);
        align-self: center;
        padding-top: 50px;
        padding-bottom: 50px;
        .itemTitle {
          font-size: 2rem;
        }
      }
      .imgContent {
        flex: 1;
      }
    }

    .sectionBack {
      bottom: 0px;
      width: 100%;
      height: 20%;
      min-height: 20px;
      background: #d9e2c4;
      position: absolute;
    }
    .sectionBack::after {
      border-bottom: 20vh solid #d9e2c4;
      border-left: 50vw solid transparent;
      content: "";
      bottom: 100%;
      right: 0;
      position: absolute;
    }
  }

  @media (max-width: 768px) {

    .sectionIntro {
      .sectionContent {
        .introCover {
          img {
            margin: 0px;
            margin-top: calc(80px - 1em);
          }
        }
        .introContent {

          .title {
            font-size: 1.5em;
          }
        }
      }
    }

      .itemsBlocks {

        padding: 1em;
        text-align: left;

        h2 {
          padding: 0px;
          margin: 0px;
          text-align: center;
        }

        .itemBlock {
          padding: 0px;
        }

        .teamBlock {
          margin: 0px;
          position: relative;
          height: 100%;
          flex-direction: column;
          .imgContent {
            width: 100%;
            border-bottom: 1em solid white;
            img {
              width: 100%;
            }
          }
          .content {
            display: block;
            padding: 1em 2em;
          }
        }

    }

    .mapBlocks {
      display: initial;
      background: yellow;
      p {
        margin-top: -1em;
      }
      iframe {
        width: 80%;
        height: 80%;
        display: block;
        margin: 0 auto;
        border: none;
        border-bottom: 4em solid transparent;
      }
      .content {
        width: 100%;
        display: block;
        padding: 1em;
        padding-bottom: 2em;
      }
    }

  }
  @media (max-width: 768px) {
    .sectionIntro {
      padding-bottom: 0px;
      .sectionContent {
        margin-top: 0px;
        padding-top: 2em;
      }
    }

    .fileList {
      ol {
        li {
          div {
            margin: 0px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Download.vue